import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/identification_img_point_android.svg")